import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";
import {deleteKaryawan, detailKaryawan, storeKaryawan} from "./karyawanSlice";
import {importEvents} from "./kalenderSlice";



const initialState = {
    listJadwalGuru: [],
    currentPage: 1,
    keterangan: null,
    urutan: {
        column: 'nama',
        order: 'asc'
    },
    search: '',


    errors: {
        nama: '',
        email: '',
        password: '',
        kelas: '',
    },
    listJadwal: [
        {
            hari: 'senin',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'selasa',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'rabu',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'kamis',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'jumat',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'sabtu',
            jam_masuk: '',
            jam_pulang: ''
        },
        {
            hari: 'minggu',
            jam_masuk: '',
            jam_pulang: ''
        }
    ],



    isInitialGet: false,
    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,

    isLoading: true,
};

export const getJadwalGuru = createAsyncThunk("jadwalguru/getJadwalGuru", async ({ search }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/teacher-schedule',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

export const importJadwal = createAsyncThunk("jadwalguru/import", async (file, { rejectWithValue }) => {
    const formData = new FormData()
    formData.append('file', file)

    try {
        const response = await axios.post(
            getBaseUrl + `/api/jurnal/import`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})


const jadwalGuruSlice = createSlice({
    name: 'jadwalguru',
    initialState,
    reducers: {
        updateFieldValue: (state, action) => {
            const { field, value } = action.payload;
            if (field === 'listJadwal') {
                state.listJadwal = value;
            } else {
                console.log(action.payload)
                state[field] = value;
            }
        },
        updateFieldError: (state, action) => {
            const { field, error } = action.payload;
            state.errors[field] = error;
        },
        updateStateJadwalGuru: (state, action) => {

            const { name, value } = action.payload
            state[name] = value
        },
        resetForm: () => initialState,
        resetField: (state, action) => {
            const field = action.payload;
            state[field] = '';
            state.errors[field] = 'Isi nama';
        },
        setImgUpload: (state, action) => {
            return action.payload
        },
        updateClassSiswa: (state, action) => {
            const { category, id } = action.payload;
            console.log(action.payload)
            state.kelas = action.payload
            // const isIdAlreadyAdded = state.listKtgkaryawan.some((item) => item.id === id);
            // if (!isIdAlreadyAdded) {
            //     state.listKtgkaryawan.push({ id, kategori });
            // }
        },
        deleteKelas: (state, action) => {
            state.kelas = null
        },
        resetListSiswa: (state) => {
            state.listSiswa = []
        },
        resetTable: (state) => {
            state.listSiswa = []
            state.isLoading = true
        },
        showFormError: (state, action) => {


            if (state.nama.trim() === '' && (action.payload === undefined || action.payload === 'nama')) {
                state.errors.nama = 'Isi nama';
            }

            if ((state.niy.trim() === '' || state.niy.length < 8) && (action.payload === undefined || action.payload === 'niy')) {
                state.errors.niy = 'Isi NIY minimal 8 digit.';
            }

            const validatePassword = (password) => {
                const uppercaseRegex = /[A-Z]/;
                const numberRegex = /[0-9]/;
                const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\-\\/]/;

                return (
                    uppercaseRegex.test(password) &&
                    numberRegex.test(password) &&
                    symbolRegex.test(password)
                );
            };

            if ((state.password.trim() === '' || state.password.length < 6) && (action.payload === undefined || action.payload === 'password')) {
                state.errors.password = 'Isi password minimal 6 karakter';
            } else if (!validatePassword(state.password) && (action.payload === undefined || action.payload === 'password')) {
                state.errors.password = 'Isi passwoed minimal ada huruf besar, angka dan simbol';
            }


            if (!state.listJadwal.some((jadwal) => jadwal.jam_masuk !== '' && jadwal.jam_pulang !== '') && (action.payload === undefined || action.payload === 'jadwal')) {
                state.errors.jadwal = 'Isi Jadwal siswa';
            }

            if (!state.isFileSend && (action.payload === undefined || action.payload === 'isFileSend')) {
                state.errors.isFileSend = 'Isi Foto Siswa';
            }

            state.isFormErrorShown = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJadwalGuru.pending, (state) => {
                console.log("halo mo")
                state.isLoading = true;
            })
            .addCase(getJadwalGuru.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.listJadwalGuru = action.payload.data;
                state.isInitialGet = true
            })
            .addCase(getJadwalGuru.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

            .addCase(importJadwal.pending, (state) => {
                state.loading = true
            })
            .addCase(importJadwal.fulfilled, (state) => {
                state.loading = false
                state.statusResApi = 'success'
                state.messageResApi = 'Jadwal berhasil di import'
                state.isDisplayMessage = true
            })
            .addCase(importJadwal.rejected, (state, action) => {
                state.loading = false
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

    }
});

export const {
    updateFieldValue, updateFieldError, resetForm, updateClassSiswa,setFormLoading, resetField, resetTable,
    setImgUpload, updateStateJadwalGuru,deleteKelas, updateStateSiswa, resetListSiswa, showFormError
} = jadwalGuruSlice.actions;
export default jadwalGuruSlice.reducer;